import { useEffect, useState } from 'react'
import { parseCoordinates, reverseGeocode } from '../utils/geocoding'

interface EinsatzortDisplayProps {
  value: string | null | undefined
  className?: string
}

export function EinsatzortDisplay({ value, className = '' }: EinsatzortDisplayProps) {
  const [displayValue, setDisplayValue] = useState<string>(() => {
    if (!value) return '—'
    if (/^-?\d+\.?\d*,\s*-?\d+\.?\d*$/.test(value.trim())) {
      return 'Lade Adresse...'
    }
    return value || '—'
  })

  useEffect(() => {
    if (!value) {
      setDisplayValue('—')
      return
    }
    if (/^-?\d+\.?\d*,\s*-?\d+\.?\d*$/.test(value.trim())) {
      const coords = value.split(',').map(s => parseFloat(s.trim()))
      if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
        reverseGeocode(coords[0], coords[1]).then(addr => {
          setDisplayValue(addr)
        }).catch(() => {
          setDisplayValue(value)
        })
      } else {
        setDisplayValue(value)
      }
    } else {
      setDisplayValue(value || '—')
    }
  }, [value])

  return <span className={className}>{displayValue}</span>
}
